import React, { Component } from 'react';
import '../css/header.css';
import ChangeLanguageButton from './ChangeLanguageButton';
import { LanguageContext } from '../contexts/LanguageContext';

const darkLogo = '/assets/netrotim_de_white.svg';
const lightLogo = '/assets/netrotim_de_black.svg';

class Header extends Component {
    static contextType = LanguageContext;

    state = {
        isMenuOpen: false,
        isAnimating: false,
        isLightMode: false
    };

    componentDidMount() {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme === "light") {
            document.body.classList.add("light-mode");
            this.setState({ isLightMode: true });
        }
    }

    toggleMenu = () => {
        if (this.state.isAnimating) return;

        this.setState(prevState => {
            const willOpen = !prevState.isMenuOpen;
            return {
                isMenuOpen: willOpen,
                isAnimating: true,
                menuClass: willOpen ? 'slide-in' : 'slide-out'
            };
        });
    };

    handleAnimationEnd = () => {
        this.setState({
            isAnimating: false,
            menuClass: this.state.isMenuOpen ? 'slide-in' : ''
        });
    };

    goToLink = (destinationName) => {
        const destination = document.getElementById(destinationName)
        destination.scrollIntoView({ behavior: "smooth" });
    }

    handleLinkClick = (destinationName) => {
        this.toggleMenu()
        this.goToLink(destinationName)
    }

    handleThemeToggle = (isLight) => {
        if (isLight) {
            document.body.classList.add("light-mode");
            localStorage.setItem("theme", "light");
        } else {
            document.body.classList.remove("light-mode");
            localStorage.setItem("theme", "dark");
        }
        this.setState({ isLightMode: isLight });
    }

    render() {
        const { translations } = this.context;
        const { isLightMode } = this.state;

        return (
            <div className='header'>
                <ChangeLanguageButton />
                
                <img 
                    src={isLightMode ? lightLogo : darkLogo} 
                    className='logo' 
                    alt='logo' 
                    onClick={() => this.handleLinkClick('home')} 
                />

                <ul className='header-links'>
                    <li onClick={() => this.handleLinkClick('home')}>{translations?.header_link_home}</li>
                    <li onClick={() => this.handleLinkClick('projects')}>{translations?.header_link_projects}</li>
                    <li onClick={() => this.handleLinkClick('skills')}>{translations?.header_link_skills}</li>
                </ul>

                <div className="hamburger" onClick={this.toggleMenu}>☰</div>

                <ul
                    className={`dropdown-menu ${this.state.menuClass}`}
                    onAnimationEnd={this.handleAnimationEnd}
                >
                    <li onClick={() => this.handleLinkClick('home')}>{translations?.header_link_home}</li>
                    <li onClick={() => this.handleLinkClick('projects')}>{translations?.header_link_projects}</li>
                    <li onClick={() => this.handleLinkClick('skills')}>{translations?.header_link_skills}</li>
                </ul>

                <div className="container">
                    <label htmlFor="switch" className="toggle">
                        <input
                            type="checkbox"
                            className="input"
                            id="switch"
                            checked={!isLightMode}
                            onChange={(e) => this.handleThemeToggle(!isLightMode)}
                        />
                        <div className="icon icon--moon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                                <path fillRule="evenodd" d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z" clipRule="evenodd" />
                            </svg>
                        </div>

                        <div className="icon icon--sun">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                                <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
                            </svg>
                        </div>
                    </label>
                </div>
            </div>
        );
    }
}

export default Header;
